/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './image-generic.stache';
import 'can/util/function/function';
import DomEventsManager from 'scripts/dom-events-manager';
import canUtil from 'scripts/utils/can';

Component.extend({
    tag: 'image-generic',
    template: template,
    viewModel: {
        visible: false,
        image: {},
        url: '',
        className: '',
        alt: '',
        define: {
            aggregate: {
                get: function() {
                    var image = this.attr('image');
                    return {
                        url: this.attr('url') || image.attr('url'),
                        className:
                            this.attr('className') || image.attr('className'),
                        alt: this.attr('alt') || image.attr('alt'),
                    };
                },
            },
            href: {
                get: canUtil.debouncedGet(
                    'visible',
                    'aggregate',
                    function(visible, aggregate) {
                        if (visible) {
                            return aggregate.url;
                        }
                        return '';
                    },
                    200,
                ),
            },
        },
    },
    helpers: {},
    events: {
        inserted: function() {
            DomEventsManager.subscribe(this);
        },
        removed: function() {
            DomEventsManager.unsubscribe(this);
        },
        onFirstShow: function() {
            this.viewModel.attr('visible', true);
        },
    },
});
